import React, { useState, useRef } from 'react';
import Header from '../../components/Header';
import './index.css';
import api from '../../services/api_irrigacao';
import { FaCloudDownloadAlt } from "react-icons/fa";
import { mask, unMask } from 'remask';
import { parse } from 'date-fns';
import { format } from 'date-fns-tz';
import styles from './styles.module.css';
import fileDownload from 'js-file-download';

export default function Importacao() {

    const [downloading, setDownloading] = useState(false);
    const [tipo, setTipo] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "IRRIGAÇÃO" },
            { id: 2, text: "OUTRAS APLICAÇÕES" },
        ],
        selectItem: 0
    });
    const [dataIni, setDataIni] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [frotaIni, setFrotaIni] = useState('');
    const [frotaFim, setFrotaFim] = useState('');
    const [fazendaIni, setFazendaIni] = useState('');
    const [fazendaFim, setFazendaFim] = useState('');
    const [talhaoIni, setTalhaoIni] = useState('');
    const [talhaoFim, setTalhaoFim] = useState('');
    const [operacaoIni, setOperacaoIni] = useState('');
    const [operacaoFim, setOperacaoFim] = useState('');
    const [produtoIni, setProdutoIni] = useState('');
    const [produtoFim, setProdutoFim] = useState('');
    const [etapa, setEtapa] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "100" },
            { id: 2, text: "103" },
            { id: 3, text: "105" },
            { id: 4, text: "106" },
        ],
        selectItem: 0
    });
    const [aplicacao, setAplicacao] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "CONVENCIONAL" },
            { id: 2, text: "HIDRO-ROLL" },
            { id: 3, text: "LOCALIZADA" },
        ],
        selectItem: 0
    });
    const [irrigacao, setIrrigacao] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "AGUA" },
            { id: 2, text: "VINHAÇA" },
        ],
        selectItem: 0
    });

    const tipoRef = useRef(null);
    const dataIniRef = useRef(null);
    const dataFimRef = useRef(null);
    const frotaIniRef = useRef(null);
    const frotaFimRef = useRef(null);
    const fazendaIniRef = useRef(null);
    const fazendaFimRef = useRef(null);
    const talhaoIniRef = useRef(null);
    const talhaoFimRef = useRef(null);
    const operacaoIniRef = useRef(null);
    const operacaoFimRef = useRef(null);
    const produtoIniRef = useRef(null);
    const produtoFimRef = useRef(null);
    const etapaRef = useRef(null);
    const aplicacaoRef = useRef(null);
    const irrigacaoRef = useRef(null);

    function handleReport() {

        var filtros = '';

        if (parseInt(tipo.selectItem) !== 0) {
            if (filtros === '') {
                filtros = '?tipo=' + tipo.selectItem;
            } else {
                filtros = filtros + '&tipo=' + tipo.selectItem;
            }
        }

        if (parseInt(etapa.selectItem) !== 0) {
            if (filtros === '') {
                filtros = '?etapa=' + etapa.selectItem;
            } else {
                filtros = filtros + '&etapa=' + etapa.selectItem;
            }

        }

        if (parseInt(aplicacao.selectItem) !== 0) {
            if (filtros === '') {
                filtros = '?aplicacao=' + aplicacao.selectItem;
            } else {
                filtros = filtros + '&aplicacao=' + aplicacao.selectItem;
            }
        }

        if (parseInt(irrigacao.selectItem) !== 0) {
            if (filtros === '') {
                filtros = '?irrigacao=' + irrigacao.selectItem;
            } else {
                filtros = filtros + '&irrigacao=' + irrigacao.selectItem;
            }
        }

        if (dataIni !== null && dataIni !== '') {
            if (filtros === '') {
                filtros = '?dataini=' + format(parse(dataIni, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            } else {
                filtros = filtros + '&dataini=' + format(parse(dataIni, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            }
        }

        if (dataFim !== null && dataFim !== '') {
            if (filtros === '') {
                filtros = '?datafim=' + format(parse(dataFim, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            } else {
                filtros = filtros + '&datafim=' + format(parse(dataFim, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            }
        }

        // if (os != null && os != '') {
        //     filtros = filtros + '&num_os=' + data;
        // }

        if (frotaIni !== null && frotaIni !== '') {
            if (filtros === '') {
                filtros = '?frotaini=' + frotaIni;
            } else {
                filtros = filtros + '&frotaini=' + frotaIni;
            }
        }

        if (frotaFim !== null && frotaFim !== '') {
            if (filtros === '') {
                filtros = '?frotafim=' + frotaFim;
            } else {
                filtros = filtros + '&frotafim=' + frotaFim;
            }
        }

        if (fazendaIni !== null && fazendaIni !== '') {
            if (filtros === '') {
                filtros = '?fazendaini=' + fazendaIni;
            } else {
                filtros = filtros + '&fazendaini=' + fazendaIni;
            }
        }

        if (fazendaFim !== null && fazendaFim !== '') {
            if (filtros === '') {
                filtros = '?fazendafim=' + fazendaFim;
            } else {
                filtros = filtros + '&fazendafim=' + fazendaFim;
            }
        }

        if (talhaoIni !== null && talhaoIni !== '') {
            if (filtros === '') {
                filtros = '?talhaoini=' + talhaoIni;
            } else {
                filtros = filtros + '&talhaoini=' + talhaoIni;
            }
        }

        if (talhaoFim !== null && talhaoFim !== '') {
            if (filtros === '') {
                filtros = '?talhaofim=' + talhaoFim;
            } else {
                filtros = filtros + '&talhaofim=' + talhaoFim;
            }
        }

        if (operacaoIni !== null && operacaoIni !== '') {
            if (filtros === '') {
                filtros = '?operacaoini=' + operacaoIni;
            } else {
                filtros = filtros + '&operacaoini=' + operacaoIni;
            }
        }

        if (operacaoFim !== null && operacaoFim !== '') {
            if (filtros === '') {
                filtros = '?operacaofim=' + operacaoFim;
            } else {
                filtros = filtros + '&operacaofim=' + operacaoFim;
            }
        }

        if (filtros === '') {
            filtros = '?relatorio=insanporop';
        } else {
            filtros = filtros + '&relatorio=insanporop';
        }

        if (produtoIni !== null && produtoIni !== '') {
            if (filtros === '') {
                filtros = '?produtoini=' + produtoIni;
            } else {
                filtros = filtros + '&produtoini=' + produtoIni;
            }
        }

        if (produtoFim !== null && produtoFim !== '') {
            if (filtros === '') {
                filtros = '?produtofim=' + produtoFim;
            } else {
                filtros = filtros + '&produtofim=' + produtoFim;
            }
        }

        if (!downloading) {
            setDownloading(true);
            api.get(`/relatorio/pdf${filtros}`, { responseType: 'blob' }).then(function (response) {
                if (response.data) {

                    if (response.data.erro) {
                        alert(response.data.erro)
                    } else {
                        fileDownload(response.data, 'RELATÓRIO DE INSUMOS ANALITICO.pdf');
                    }

                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setDownloading(false);
            });
        }
    }

    function renderSpin() {
        if (downloading) {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        } else {
            return (
                <div className="buttondownload">

                    <spam
                        className=" click btn btn-success "
                        onClick={() => handleReport()}
                    >
                        <FaCloudDownloadAlt /> DOWNLOAD
                    </spam>

                </div>
            )
        }

    }

    function handleSelecTipo(value, obj) {
        const tiposelected = Object.assign([], obj);
        tiposelected.selectItem = value;
        return tiposelected;
    }

    function handledown(e, ref) {
        if (e.key === "Enter") {
            ref.current.focus();
        }
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        return maskedValue;
    }

    return (
        <div className="container-lg">
            <Header title="RELATÓRIO ANALITICO - APLICAÇÃO INSUMOS POR OPERAÇÕES" />
            {/* <div className="content form">
                <div className="column-desc">
                    <label>TIPO:</label>
                </div>
                <div className="column-tipo">
                    <select
                        className="col-md-12 combobox  edit form-control"
                        id="tipo"
                        value={tipo.selectItem}
                        onChange={(e) => setTipo(handleSelecTipo(e.target.value, tipo))}
                        ref={tipoRef}
                        onKeyDown={(e) => handledown(e, dataIniRef)}
                    >
                        {tipo.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
            </div> */}
            <div className="content form">
                <div className="column-desc">
                    <label>PERÍODO:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="dataini"
                        ref={dataIniRef}
                        value={dataIni}
                        className="form-control edit"
                        placeholder="DATA INICIAL"
                        onKeyDown={(e) => handledown(e, dataFimRef)}
                        onChange={(e) => setDataIni(handleMaskData(e.target.value))}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="datafim"
                        ref={dataFimRef}
                        value={dataFim}
                        className="form-control edit"
                        placeholder="DATA FINAL"
                        onKeyDown={(e) => handledown(e, frotaIniRef)}
                        onChange={(e) => setDataFim(handleMaskData(e.target.value))}
                    />
                </div>
                <div className="column-desc">
                    <label>FROTA:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={frotaIniRef}
                        value={frotaIni}
                        className="form-control edit"
                        placeholder="FROTA INICIAL"
                        onKeyDown={(e) => handledown(e, frotaFimRef)}
                        onChange={(e) => setFrotaIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={frotaFimRef}
                        value={frotaFim}
                        className="form-control edit"
                        placeholder="FROTA FINAL"
                        onKeyDown={(e) => handledown(e, fazendaIniRef)}
                        onChange={(e) => setFrotaFim(e.target.value)}
                    />
                </div>
                <div className="column-desc">
                    <label>FAZENDA:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={fazendaIniRef}
                        value={fazendaIni}
                        className="form-control edit"
                        placeholder="FAZ. INICIAL"
                        onKeyDown={(e) => handledown(e, fazendaFimRef)}
                        onChange={(e) => setFazendaIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={fazendaFimRef}
                        value={fazendaFim}
                        className="form-control edit"
                        placeholder="FAZ. FINAL"
                        onKeyDown={(e) => handledown(e, talhaoIniRef)}
                        onChange={(e) => setFazendaFim(e.target.value)}
                    />
                </div>
                <div className="column-desc">
                    <label>TALHÃO:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={talhaoIniRef}
                        value={talhaoIni}
                        className="form-control edit"
                        placeholder="TAL. INICIAL"
                        onKeyDown={(e) => handledown(e, talhaoFimRef)}
                        onChange={(e) => setTalhaoIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={talhaoFimRef}
                        value={talhaoFim}
                        className="form-control edit"
                        placeholder="TAL. FINAL"
                        onKeyDown={(e) => handledown(e, tipoRef)}
                        onChange={(e) => setTalhaoFim(e.target.value)}
                    />
                </div>
            </div>
            <div className="content form">
                <div className="column-desc">
                    <label>TIPO:</label>
                </div>
                <div className="column-tipo">
                    <select
                        className="col-md-12 combobox  edit form-control"
                        id="tipo"
                        value={tipo.selectItem}
                        onChange={(e) => setTipo(handleSelecTipo(e.target.value, tipo))}
                        ref={tipoRef}
                        onKeyDown={(e) => handledown(e, etapaRef)}
                    >
                        {tipo.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
                <div className="column-desc">
                    <label>ETAPA:</label>
                </div>
                <div className="column-tipo">
                    <select
                        className="col-md-12 combobox  edit form-control"
                        value={etapa.selectItem}
                        onChange={(e) => setEtapa(handleSelecTipo(e.target.value, etapa))}
                        ref={etapaRef}
                        onKeyDown={(e) => handledown(e, aplicacaoRef)}
                    >
                        {etapa.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
                <div className="column-desc">
                    <label>APLICAÇÃO:</label>
                </div>
                <div className="column-tipo">
                    <select
                        className="col-md-12 combobox  edit form-control"
                        value={aplicacao.selectItem}
                        onChange={(e) => setAplicacao(handleSelecTipo(e.target.value, aplicacao))}
                        ref={aplicacaoRef}
                        onKeyDown={(e) => handledown(e, irrigacaoRef)}
                    >
                        {aplicacao.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
                <div className="column-desc">
                    <label>IRRIGAÇÃO:</label>
                </div>
                <div className="column-tipo">
                    <select
                        className="col-md-12 combobox  edit form-control"
                        value={irrigacao.selectItem}
                        onChange={(e) => setIrrigacao(handleSelecTipo(e.target.value, irrigacao))}
                        ref={irrigacaoRef}
                        onKeyDown={(e) => handledown(e, produtoIni)}
                    >
                        {irrigacao.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>

            </div>

            <div className="content form">

                <div className="column-desc">
                    <label>PRODUTO:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={produtoIniRef}
                        value={produtoIni}
                        className="form-control edit"
                        placeholder="PROD. INICIAL"
                        onKeyDown={(e) => handledown(e, produtoFimRef)}
                        onChange={(e) => setProdutoIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={produtoFimRef}
                        value={produtoFim}
                        className="form-control edit"
                        placeholder="PROD. FINAL"
                        onKeyDown={(e) => handledown(e, operacaoIniRef)}
                        onChange={(e) => setProdutoFim(e.target.value)}
                    />
                </div>

                <div className="column-desc">
                    <label>OPERAÇÃO:</label>
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={operacaoIniRef}
                        value={operacaoIni}
                        className="form-control edit"
                        placeholder="OP. INICIAL"
                        onKeyDown={(e) => handledown(e, operacaoFimRef)}
                        onChange={(e) => setOperacaoIni(e.target.value)}
                    />
                </div>
                <div className="column-num">
                    <input
                        type="text"
                        id="data"
                        ref={operacaoFimRef}
                        value={operacaoFim}
                        className="form-control edit"
                        placeholder="OP. FINAL"
                        // onKeyDown={(e) => handledown(e, tipoRef)}
                        onChange={(e) => setOperacaoFim(e.target.value)}
                    />
                </div>

            </div>


            {renderSpin()}

        </div>
    )
}